<template>
    <div class="editEmployeeAdminVue">
      <!-- HUGE COMMENT -->
        <!-- Please add autocomplete='off' to all input fields or at form level -->   
        <div class="c-responsive-fixwidth">
            <div class="clearfix o-skillset-area">
                <div class="employer-info">
                    <div class="field-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                    <div class="c-user-tab-content clearfix o-skillset-area">
                                        <p>{{ $t('basic_info') }}:</p>
                                        <div v-loading="loading" class="field-group">
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('select_status')}}:</label>
                                                    <div class="o-cutsomSelect">
                                                        <select @change="onUpdateInputField" v-model="adminSettings.status" class="form-control" @blur="blur($event)" name="status" data-vv-delay="500">
                                                            <option value="">— {{ $t('none_assigned') }} —</option>
                                                            <option v-for="(status,index) in statusList" :key="index" :value="status.id">{{status.name}}</option>
                                                        </select>
                                                        <!-- <span v-show="errors.has('status') && this.validation_err!=0" class="err-msg">{{ errors.first('status') }}</span> -->
                                                        <span class="err-msg">**{{ $t('required_field') }}**</span>

                                                    </div>
<!--
                                                        <div class="o-custom-dropdown">
                                                        <select class="form-control">
                                                            <option>— None Assigned —</option>
                                                            <option>— None Assigned —</option>
                                                        </select>
                                                        <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </div>
-->
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('member_since')}}:</label>

                                                    <el-date-picker
                                                        @change="onUpdateInputField"
                                                        name="date"
                                                        v-validate="{ required: true}"
                                                        v-model="adminSettings.memberSince"
                                                        type="date"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="getDatePlaceholder()">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('date_of_hire') }}:</label>

                                                    <el-date-picker
                                                        @change="onUpdateInputField"
                                                        name="date"
                                                        v-validate="{ required: true}"
                                                        v-model="adminSettings.dateOfHire"
                                                        type="date"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="getDatePlaceholder()">
                                                    </el-date-picker>
                                                </div>
                                            </div>

                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('total_shifts' )}}:</label>

                                                <input v-model="adminSettings.totalShifts" type="number" @change="onUpdateInputField" class="form-control" :placeholder="$t('enter_shift')">
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group ">
                                                    <label class="common-label-text">{{ $t('seniority') }}:</label>

                                                <input v-model="adminSettings.seniority" type="number" @change="onUpdateInputField" class="form-control" :placeholder="$t('enter_seniority')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field-group" style="display: none;" v-if="this.empDetails.notes_documents !='disabled'">
                        <div class="row">
                            <div class="col-sm-6 o-margin-bottom-20">
                                <div class="col-md-12 o-no-padding">
                                    <h5 class="h2">{{ $t('notes') }}:</h5>
                                </div>
                                <div class="col-md-12 o-no-padding">
                                    <div class="o-notes-toggle-container c-common-box-shadow c-radius3">

                                        <div v-for="(note,key) in notes" :key="key" v-bind:class="(key==0)?'js-active-togg':''" class="o-toggle-header">
                                            <a href="javascript: void(0)" v-on:click="toggleHeader(key)" :id="key" class="o-toggle-trigger">
                                                <i v-bind:class="(key==0)?'fa-minus-circle':'fa-plus-circle'" class="fa " aria-hidden="true"></i>
                                            </a>
                                            <div class="o-toggle-content">
                                                <div v-bind:class="(key==0)?'js-togg-expand-height':''" class="js-note-txt-expand ">
                                                    <p class="ps1">{{ note.content }}</p>
                                                </div>
                                                <div class="o-inlineblock o-attachmentdate">
                                                    <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(note.created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(note.created_at)}}
                                                </div>
                                                <h5 class="ps2">Created by: {{ getNoteAuthor(note) }}
                                                    <a href="javascript: void(0)" @click="editSingleNotes(note)" v-show="(getNoteAuthor(note)!='Me')? false:true"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                                </h5>
                                    
                                            </div>
                                        </div>
                                        <div v-if="notes.length == 0" class="">
                                            <div class="o-attachment-strip">{{ $t('no_notes_found') }}</div>
                                        </div> 
                                    </div>
                                </div>
                                <div class="col-md-12 o-no-padding">
                                    <a href="javascript: void(0)" @click="addSingleNotes()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i>{{$t('add_note')}}</a>
                                </div>
                            </div>
                            <div class="col-sm-6 o-no-padding o-margin-bottom-20">
                                <div class="col-md-12">
                                    <h5 class="h2">{{$t('documents')}}:</h5>
                                </div>
                                <div v-if="attachmentList.length>0" class="col-md-12">
                                    <div class="o-notes-toggle-container c-bg-white u-pad-all-15 c-common-box-shadow c-radius3">
                                        <ul class="o-documents-container">
                                            <li v-for="(attachment, key, index) in attachmentList" :key="index">
                                                <div class="col-md-4 o-no-padding o-uploaded-doc">
                                                    <span><i class="fa fa-file-o" aria-hidden="true"></i></span> {{snippet(attachment.filename)}}
                                                </div>
                                                <div class="col-md-8 o-no-padding o-uploaded-doc-owner">
                                                    <div class="o-inlineblock o-attachmentdate">
                                                        <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(empDetails.attachments[key].created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(empDetails.attachments[key].created_at)}}
                                                    </div>
                                                    <div class="o-inlineblock text-right">
                                                        <h5>Created by: {{ getNoteAuthor(attachment) }}
                                                            <a href="javascript: void(0)" @click="deleteAtteachment(attachment.id)">
                                                                <i v-show="(getNoteAuthor(attachment)!='Me')? false:true" class="fa fa-trash-o" aria-hidden="true"></i>
                                                            </a>
                                                            <a href="javascript: void(0)" @click="show(0 , key, attachment.filename, attachment.path)" class="o-files-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                            <a v-if="getPower('myProfileFileDownload')" :href="globalBaseUrl + 'auth/'+ decodeFileId(attachment.id)+'/download'" :class="'files'+index+key" download class="o-files-download"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                                                        </h5>
                                                        <div :class="'images0'+key" v-viewer="{movable: true}">
                                                            <img :src="attachment.path" :key="attachment.path" v-show="false">
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>                    
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="attachmentList.length == 0" class="col-md-12">
                                    <div class="o-file-strip">{{$t('no_document_uploaded')}}</div>
                                </div> 
                                <div class="col-md-12">
                                    <h5 class="h2">{{$t('upload_documents')}}:</h5>
                                </div>
                                <div class="col-md-12">
                                    <ul class="o-filter-area">
                                        <li>
                                            <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> {{$t('add_files')}}</button>
                                                <input type="file" @change="addFileToList($event)" />
                                            </label>
                                        </li>
                                        <li><a href="javascript: void(0)" @click="uploadImage()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i> {{$t('start_upload')}}</a></li>
                                        <li><a href="javascript: void(0)" @click="cancelUpload()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> {{$t('cancel_upload')}}</a></li>
                                        <li><a href="javascript: void(0)" @click="deleteDocuments()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i> {{$t('delete')}}</a></li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <div class="upload-table-list o-uploaded-box c-common-box-shadow">
                                        <div class="calls-table-row o-upload-devider" v-for="(img,key) in new_files" :key="key" v-loading.this.lock="img.uploading">
                                            <div class="calls-table-cell">
                                                <div class="checkbox o-custom-radio">
                                                    <label>
                                                        <input type="checkbox" :name="key" value="" v-model="img.status">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </div>
                                        <div class="calls-table-cell">

                                            <div class="calls-table-cell-inner-table">
                                                <div class="o-accordion-subtext user-icon o-uploaded-image o-no-padding-left">
                                                    <div class="o-post-logged o-post-logged--table-user">
                                                        <div class="o-user-profile-img o-user-profile-img--upload">
                                                            <img v-if="!img.fileExtension" :src="img.img">
                                                            <img v-else src="static/assets/images/Document-icon.png">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <div>{{img.name}}</div>
                                                </div>
                                            </div>
                                            <el-progress :percentage="img.progress" :status="(img.progress == 100)?'success':''"></el-progress>          
                                        </div>
                                    </div>
                                    <div v-if="new_files.length == 0" class="">
                                        <div class="o-attachment-strip">{{$t('upload_your_documents')}}</div>
                                    </div> 
                                </div>
                            </div>
                            <div v-if="new_files.length > 0" class="col-md-12">
                                <ul class="o-filter-area">
                                    <li>
                                        <a href="javascript: void(0)" @click="cancelSave()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> {{$t('cancel')}}</a>
                                    </li>
                                    <li>
                                        <a href="javascript: void(0)" @click="uploadSave()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal name="add-single-notes"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                <div role="document">
                   <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeSingleNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">{{$t('add_notes')}}</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-input--fullwidth">
                                            <textarea
                                                autocomplete="off" 
                                                class="form-control" 
                                                rows="4" 
                                                :placeholder="$t('type_your_note')" 
                                                v-validate="{required: true}" 
                                                name="note" v-model="addEmployer.note"
                                                data-vv-scope="form-addNote">
                                            </textarea>
                                            <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeSingleNotes()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> {{$t('cancel')}}</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="addNewNote('form-addNote')" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                   <!-- /.modal-content -->
                </div>
               <!-- /.modal-dialog -->
            </div>
        </modal>
        
        <modal name="edit-single-notes"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
               <div role="document">
                   <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeEditSingleNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">{{$t('edit_notes')}}</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-input--fullwidth">
                                            <textarea 
                                                autocomplete="off"
                                                class="form-control" 
                                                rows="4" 
                                                :placeholder="$t('edit_your_note')" 
                                                v-validate="{required: true}" 
                                                name="note" 
                                                v-model="addEmployer.note"
                                                data-vv-scope="form-editNote">                  
                                            </textarea>
                                            <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                        </div>
                        
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeEditSingleNotes()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> {{$t('cancel')}}</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="editNewNote('form-editNote')" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</a>
                                </li>
                            </ul>
                        </div>

                    </div>
                   <!-- /.modal-content -->
               </div>
               <!-- /.modal-dialog -->
            </div>
        </modal>
    </div>
</template>

<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import { bus } from '../../main';
    import service from '../../services.js';
    import { global } from '../../global.js';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    export default {
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                globalBaseUrl: '',
                pictureExtension: false,
                validation_err: 0,
                statusList: [],
                loading: false,
                adminSettings: {
                    memberSince: '',
                    dateOfHire: '',
                    totalShifts: '',
                    seniority: '',
                    status: '',
                },
                notes: [],
                editNote: {
                    content: '',
                    noteable_id: '',
                    noteable_type: '',
                    uploader: '',
                    noteID: '',
                },
                addEmployer: {
                    note: '',
                },
                attachmentList: [],
                new_files: [],
                getEmpDetails: [],

            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
                jobID: 'selectedJobId',
                userId: 'userID',
                userName: 'userName',
                userFullName: 'userFullName',
                employeeId: 'employeeId'
            })
        },
        watch: {
            empDetails: function(newData) {
                //console.log(newData);
                this.adminSettings.status = newData.employee_status.id;
                this.adminSettings.memberSince = newData.member_since;
                this.adminSettings.dateOfHire = newData.date_of_hire;
                this.adminSettings.totalShifts = newData.total_shifts;
                this.adminSettings.seniority = this.getRoundOffSkillSeniority(newData.seniority);
                this.notes = newData.notes;
                //console.log('DATA', newData);
                //this.employeeNotes = this.newData.notes;
                //console.log(this.employeeNotes);
            }
        },
        methods: {
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            getPower(data) {
                //console.log('headernav',typeof dateTimeConvert.checkAccess(data));
                return dateTimeConvert.checkAccess(data);
            },
            show(index, listid, fileName, path) {
                if (listid != undefined) {
                    var extension = fileName.split('.').pop();
                    if (['jpg', 'jpeg', 'ico', 'png', 'svg', 'tif', 'tiff', 'gif', 'bmp'].indexOf(extension) > -1) {
                        this.$el.querySelector('.images' + index + listid).$viewer.show();
                    } else if (['xls', 'csv', 'xlsx', 'xlr', 'ods', 'doc', 'odt', 'rtf', 'tex', 'wps', 'wks'].indexOf(extension) > -1) {
                        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + path);
                        // window.open('https://view.officeapps.live.com/op/view.aspx?src=' + this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    } else if (['pdf', 'text', 'txt'].indexOf(extension) > -1) {
                        window.open('https://docs.google.com/viewer?url=' + path);
                        // window.open('https://docs.google.com/viewer?url=' + this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    } else {
                        window.open(this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    }
                }
            },
            decodeFileId(id){
                return btoa(id);
            },
            snippet(value) {
                if (value.length > 25)
                    return value.slice(0, 25) + '  ...';
                else
                    return value;
            },
            getDate(str) {
                return dateTimeConvert.localDate(str);
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDateUtc(str) {
                return dateTimeConvert.dateFromUtc(str);
            },
            getTimeUtc(dateTime) {
                return dateTimeConvert.timeFromUtc(dateTime);
            },
            editSingleNotes(note) {
                this.$modal.show("edit-single-notes");
                this.addEmployer.note = note.content;
                var noteActivity = JSON.parse(note.activity);

                this.editNote.noteID = note.id;
                this.editNote.content = this.addEmployer.note;
                this.editNote.noteable_id = note.noteable_id;
                this.editNote.noteable_type = note.noteable_type;
                this.editNote.uploader = this.userId;
            },
            closeEditSingleNotes() {
                this.$modal.hide("edit-single-notes");
            },
            editNewNote(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        this.editNote.content = this.addEmployer.note;
                        service.put('note/' + this.editNote.noteID, this.editNote, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            //this.employers = res.data.result;
                            //this.closeSingleNotes();
                            setTimeout(() => {
                                this.$modal.hide('edit-single-notes');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Employer Note Updated Successfully.',
                                type: 'success'
                            });
                            //console.log('success note');
                            this.onUpdateOrAdd();
                        }).catch((err) => {
                            //console.log(err);
                            this.$Progress.finish();
                            //console.log('error note');
                        });
                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            addNewNote(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        // console.log("success");
                        this.validation_err = 0;
                        var activityID = {
                            "uploader_id": this.userId,
                            "uploaded_by": this.userFullName,
                        }
                        activityID = JSON.stringify(activityID);
                        var jobNote = {
                            noteable_id: atob(this.$route.params.empId),
                            noteable_type: 'employee',
                            activity: activityID,
                            content: this.addEmployer.note,
                        };
                        //console.log(jobNote);
                        service.post('note', jobNote, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            setTimeout(() => {
                                this.$modal.hide('add-single-notes');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Job Note Added Successfully.',
                                type: 'success'
                            });
                            //console.log('success note');
                            this.onUpdateOrAdd();
                        }).catch((err) => {
                            //console.log(err);
                            this.$Progress.finish();
                            // console.log('error note');
                        });
                    } else {
                        console.log("error");
                        this.validation_err = 1;
                    }
                });
            },
            onUpdateOrAdd() {
                bus.$emit('onUpdateOrAdd', "Msg");
            },
            addSingleNotes() {
                this.$modal.show("add-single-notes");
                this.addEmployer.note = '';
            },
            closeSingleNotes() {
                this.$modal.hide("add-single-notes");
            },
            getNoteAuthor(note) {
                var getAuthor = JSON.parse(note.activity);
                if(getAuthor){
                    if (getAuthor.uploader_id == this.userId) {
                        return "Me";
                    } else {
                        return getAuthor.uploaded_by;
                    }
                }else{
                    return "";
                }
            },
            toggleHeader(id) {
                //console.log(id);
                if ($('#' + id).children().hasClass("fa-plus-circle")) {
                    //console.log("open");
                    $('#' + id).parent().addClass('js-active-togg');
                    $('#' + id).children().removeClass('fa-plus-circle').addClass('fa-minus-circle');
                    $('#' + id).siblings(".o-toggle-content").children(".js-note-txt-expand").addClass("js-togg-expand-height");
                } else {
                    //console.log('close');
                    $('#' + id).parent().removeClass('js-active-togg');
                    $('#' + id).children().removeClass('fa-minus-circle').addClass('fa-plus-circle');
                    $('#' + id).siblings(".o-toggle-content").find(".js-note-txt-expand").removeClass("js-togg-expand-height");
                }
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                // #1691 (FS-16380) — do NOT blank a seniority of 0 here. This turned a
                // legitimate 0 into '' before sending, and the API then stored NULL, so
                // a seniority of 0 could never be saved. 0 is a real value; send it.
                bus.$emit('onUpdateAdminSettings', this.adminSettings);
                //console.log(this.adminSettings);
            },

            addFileToList(e) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files.push({
                                'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report',
                                'fileExtension': this.setPicture(type[0])
                            });
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 500 kb'
                        });
                    }

                }
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            uploadImage() {
                //console.log(this.new_files);
                for (var i = 0; i < this.new_files.length; i++) {

                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                        this.new_files[i].progress = 20;
                        this.uploadService(this.new_files[i]).then((path) => {
                            //console.log(path);
                        }).catch((err) => {
                            console.log(err);
                        });

                    }
                    //console.log(this.new_files);
                }
            },
            uploadService(img) {
                img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            img.path = res.data.result.path;
                            img.progress = 100;
                            img.uploaded = true;
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },
            uploadSave() {
                let self = this;
                //console.log(this.new_files);
                let unUploadFile = this.new_files.filter(function(file) {
                    //console.log(file.uploaded); 
                    return (file.uploaded == false);
                });
                //console.log(unUploadFile);
                if (unUploadFile.length > 0) {
                    this.$confirm('Some file are still not uploaded. Do you want to save all files ?', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        type: 'warning'
                    }).then(() => {
                        this.new_files.forEach(function(file) {
                            if (!file.status) {
                                file.status = true;
                            }
                        });
                        // Upload un-uploaded files.
                        for (var i = 0; i < this.new_files.length; i++) {

                            if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                                this.new_files[i].progress = 20;
                                this.uploadService(this.new_files[i]).then((path) => {

                                    //save all file in database.
                                    for (var i = 0; i < this.new_files.length; i++) {
                                        let activityData = {
                                            uploader_id: this.userId,
                                            uploaded_by: this.userFullName,
                                        };
                                        let fromData = {
                                            attachable_id: atob(this.$route.params.empId),
                                            created_by: this.employeeId,
                                            attachable_type: 'employee',
                                            filename: this.new_files[i].name,
                                            description: 'Employee Document',
                                            label: this.new_files[i].label,
                                            path: this.new_files[i].path,
                                            activity: JSON.stringify(activityData)
                                        };
                                        this.saveService(fromData).then((res) => {
                                            //console.log(res);
                                            this.$message({
                                                type: 'success',
                                                message: 'File saved successfully'
                                            });
                                            this.new_files = [];
                                        }).catch((err) => {
                                            console.log(err);
                                        });
                                    }

                                }).catch((err) => {
                                    console.log(err);
                                });

                            }
                            //console.log(this.new_files);
                        }
                        //console.log("data");
                    }).catch(() => {

                        /*delete un-uploaded files.*/
                        this.new_files.forEach(function(file, key) {
                            //console.log(key);
                            if (!file.uploaded) {
                                self.new_files.splice(key, 1);
                            }
                        });

                        /* save uploaded files.*/
                        for (var i = 0; i < this.new_files.length; i++) {
                            let activityData = {
                                uploader_id: this.userId,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: atob(this.$route.params.empId),
                                created_by: this.employeeId,
                                attachable_type: 'employee',
                                filename: this.new_files[i].name,
                                description: 'Employee Document',
                                label: this.new_files[i].label,
                                path: this.new_files[i].path,
                                activity: JSON.stringify(activityData)
                            };
                            this.saveService(fromData).then((res) => {
                                this.$message({
                                    type: 'success',
                                    message: 'File saved successfully'
                                });
                                this.new_files = [];
                            }).catch((err) => {
                                console.log(err);
                            });
                        }
                    });

                } else {
                    //console.log("uploaded");
                    for (var i = 0; i < this.new_files.length; i++) {
                        let activityData = {
                            uploader_id: this.userId,
                            uploaded_by: this.userFullName,
                        };
                        let fromData = {
                            attachable_id: atob(this.$route.params.empId),
                            created_by: this.employeeId,
                            attachable_type: 'employee',
                            filename: this.new_files[i].name,
                            description: 'Employee Document',
                            label: this.new_files[i].label,
                            path: this.new_files[i].path,
                            activity: JSON.stringify(activityData)
                        };
                        this.saveService(fromData).then((res) => {
                            this.$message({
                                type: 'success',
                                message: 'File saved successfully'
                            });
                            this.new_files = [];
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
                //document.reload();
                this.onUpdateOrAdd();
            },
            saveService(data) {
                //img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment', data, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            this.onUpdateOrAdd();
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },
            cancelSave() {
                this.new_files = [];
            },
            cancelUpload() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].uploaded == false) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },
            deleteDocuments() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].status == true) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },
            deleteAtteachment(id) {
                this.$confirm('ATTACHMENT will be removed from EMPLOYEE LIST. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('attachment/destroy', {
                        'attachment_id': id
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.onUpdateOrAdd();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            }
        },
        created() {

            this.loading = true;

            this.globalBaseUrl = global[0].BASE_URL;
            service.get('employee/employee_status_lite', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
                this.statusList = res.data.result;
                this.statusList.sort(function(a, b) {
                  if (Number(a.priority) < Number(b.priority)) return -1;
                  if (Number(a.priority) > Number(b.priority)) return 1;
                  return 0;
                });

                this.loading = false;
                //console.log(this.statusList);

            }).catch((err) => {
                console.log(err);
                this.loading = false;
            });

            this.adminSettings.status = (this.empDetails.employee_status)?this.empDetails.employee_status.id:'';
            this.adminSettings.memberSince = (this.empDetails.member_since != null && this.empDetails.member_since != '0000-00-00 00:00:00') ? this.empDetails.member_since.split(" ")[0] : "";
            this.adminSettings.dateOfHire = (this.empDetails.date_of_hire && this.empDetails.date_of_hire != null && this.empDetails.date_of_hire != '0000-00-00 00:00:00') ? this.empDetails.date_of_hire.split(" ")[0] : "";
            this.adminSettings.totalShifts = this.empDetails.total_shifts;
            this.adminSettings.seniority = this.getRoundOffSkillSeniority(this.empDetails.seniority);
            if(this.empDetails.notes_documents !='disabled'){
                this.notes = this.empDetails.notes;
            }
            //this.notes = this.empDetails.notes;
            this.attachmentList = this.empDetails.attachments;
            this.getEmpDetails = this.empDetails;
            //console.log(this.adminSettings);
            //console.log("GET EMP DETAILS", this.getEmpDetails);
            this.onUpdateInputField();
            //console.log('DATA', this.notes);
        }
    }

</script>
<style scoped>


</style>
